import React, { useEffect } from 'react';

import { useFilters } from '@/utils';

import { useFavoriteReportHandler } from '../../hooks';
import { ReportDetailsProps, ReportTab, ReportTypeKeys } from '../../report.types';
import { useGetReportEmployerId } from '../hooks';
import ReportDetailsBase from '../ReportDetailsBase';

import { CIPStatusReportTableParams, CIPStatusSummaryReportParams } from './CIPStatusReport.types';
import CIPStatusReportSummary from './CIPStatusReportSummary';
import CIPStatusReportTable from './CIPStatusReportTable';

type FiltersValues = CIPStatusReportTableParams &
  CIPStatusSummaryReportParams & {
    tab: ReportTab;
  };
interface Props extends ReportDetailsProps<FiltersValues> {
  employerId?: string;
}
const CIPStatusReportsDetails: React.FC<Props> = ({
  defaultEmployerId,
  defaultEmployerIds,
  defaultTab,
  isPreviewMode,
  onChangeFilters,
  defaultFilterValues,
  employerId: paramEmployerId,
}) => {
  const employerId = useGetReportEmployerId();
  const { filtersValues, setFilterValue } = useFilters<FiltersValues>(
    {
      tab: defaultTab || ReportTab.Summary,
      employerId: paramEmployerId || defaultEmployerId || employerId || '',
      employerIds: defaultEmployerIds || employerId ? [employerId] : [],
      searchString: '',
      isSSNShowed: false,
      CIPStatuses: [],
      enrollmentStatuses: [],
      accountStatuses: [],
      reason: [],
      startDate: null,
      endDate: null,
      employmentStatuses: [],
      ...defaultFilterValues,
    },
    {
      disabled: isPreviewMode,
      autoClear: true,
    }
  );
  useEffect(() => {
    if (employerId && !filtersValues.employerId) {
      setFilterValue.employerId(employerId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employerId]);
  useEffect(() => {
    if (defaultTab) {
      setFilterValue.tab(defaultTab);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultTab]);
  useEffect(() => {
    if (isPreviewMode && onChangeFilters) {
      onChangeFilters(filtersValues);
    }
  }, [filtersValues, isPreviewMode, onChangeFilters]);
  const { isFavorite, handleToggleReportKey } = useFavoriteReportHandler(ReportTypeKeys.CIPStatus);
  return (
    <ReportDetailsBase
      isPreviewMode={isPreviewMode}
      isFavorite={isFavorite}
      onToggleFavorite={handleToggleReportKey}
      tab={filtersValues.tab}
      onSetTab={setFilterValue.tab}
      title="CIP Status"
    >
      {filtersValues.tab === ReportTab.Report ? (
        <CIPStatusReportTable
          defaultEmployerId={defaultEmployerId}
          isPreviewMode={isPreviewMode}
          key={filtersValues.tab}
          filtersValues={filtersValues}
          onSetFilterValue={setFilterValue}
        />
      ) : (
        <CIPStatusReportSummary
          defaultEmployerId={defaultEmployerId}
          isPreviewMode={isPreviewMode}
          filtersValues={filtersValues}
          onSetFilterValue={setFilterValue}
        />
      )}
    </ReportDetailsBase>
  );
};

export default CIPStatusReportsDetails;
